<template>
  <a-layout class="list-full-height">
    <a-layout class="p-m">
      <a-layout-sider width="220" class="bg_white">
        <a-menu v-model="current" mode="inline">
          <a-menu-item 
            data-ga-id="通知-筛选通知类型" :data-ga-value="v.label"
            v-for="v in typeList" :key="v.value" @click="handleTypeClick(v.value)"
            >
            <span>{{ v.label }}</span>
          </a-menu-item>
        </a-menu>
      </a-layout-sider>
      <a-layout-content class="gap-l-20 bg_white p-m list-box">
        <div class="m-b-md" style="overflow:hidden">
          <a-select v-model="selectValue" :options="status" class="status-select" @change="handleSelectChange"></a-select>
          <a-button @click="handleReadAll" v-show="Number(current) > 0" type="primary" class="gap-l-10">全部已读</a-button>
        </div>
        <a-table
          :loading="loading"
          :columns="columns"
          :dataSource="list"
          :rowKey="row => row.id"
          :pagination="{ ...pagination, showTotal: total => `共${total}条` }"
          @change="handleTableChange"
        >
          <a @click="handleJumpToDetail(row)" href="javascript:;" v-if="row.companyName" slot="company" slot-scope="row">{{ row.companyName }}</a>
          <span v-else slot="company">---</span>
          <a @click="handleJumpToDetail(row)" href="javascript:;" v-if="!row.companyName" slot="content" slot-scope="row">{{ row.content }}</a>
          <span v-else slot="content" slot-scope="row">{{ row.content }}</span>
          <span :class="{ 'text-danger': isRead === 0 }" slot="status" slot-scope="isRead">{{ isRead === 1 ? '已读' : '未读' }}</span>
        </a-table>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import { notifyList, notifyRead, notifyReadAll } from '@/api/notify.js';
const typeList = [
  { value: '', label: '全部' },
  { value: 1, label: '通知消息（@你）' },
  { value: 2, label: '互动消息（互动）' },
  { value: 3, label: '系统智能提醒' }
];
const status = [
  { value: '', label: '全部' },
  { value: '0', label: '未读' },
  { value: '1', label: '已读' }
];
const columns = [
  {
    title: '公司名称',
    align: 'center',
    scopedSlots: { customRender: 'company' }
  },
  { title: '内容', scopedSlots: { customRender: 'content' }, width: 320 },
  {
    title: '类型',
    dataIndex: 'type',
    align: 'center',
    customRender: type => {
      return type === 1 ? '通知消息' : type === 2 ? '互动消息' : type === 3 ? '系统智能提醒' : '---';
    }
  },
  {
    title: '状态',
    dataIndex: 'isRead',
    align: 'center',
    scopedSlots: { customRender: 'status' }
  },
  { title: '创建时间', dataIndex: 'createAt', align: 'center' }
];
export default {
  data() {
    return {
      typeList,
      status,
      current: [''],
      loading: false,
      columns,
      list: [],
      pagination: {
        page: 1,
        total: 0
      },
      selectValue: ''
    };
  },
  methods: {
    handleReadAll() {
      this.loading = true;
      notifyReadAll(this.current[0]).then(res => {
        this.loading = false;
        if (res.code === 200) {
          this.$message.success(res.data || 'success');
          this.getList(this.current[0], this.selectValue);
        }
      });
    },
    handleJumpToDetail(row) {
      if (row.isRead === 0) {
        notifyRead(row.id).then(res => {
          if (res.code === 200) {
            this.$message.success(res.data || 'success');
            let url = `${window.location.origin}`;
            let query = ``;
            switch (row.page) {
            case 1:
              //跳转项目页面
              query = `?id=${row.companyId}`;
              url = `${url}/project/detail`;
              break;
            case 2:
              //跳转Vote页面
              query = `?companyId=${row.companyId}`;
              url = `${url}/project/meetingList`;
              break;
            case 3:
              //跳转meeting页面
              query = ``;
              url = `${url}/meeting`;
              break;
            }
            window.open(`${url}${query}`);
            //点击公司名，标记消息已读，跳转到对应页面
          }
        });
      }
    },
    handleTypeClick(value) {
      this.pagination.page = 1;
      this.getList(value, this.selectValue);
    },
    handleTableChange(pagination) {
      // 分页
      this.pagination.page = pagination.current;
      this.getList(this.current[0], this.selectValue);
    },
    handleSelectChange(e) {
      this.pagination.page = 1;
      this.getList(this.current[0], e);
    },
    getList(type = '', isRead = '') {
      this.loading = true;
      notifyList({ ...this.pagination, type, isRead }).then(res => {
        this.loading = false;
        this.list = res.data.list;
        this.pagination.page = res.data.page;
        this.pagination.total = res.data.total;
      });
    }
  },
  mounted() {
    const { type, status } = this.$route.query;
    this.current = [type];
    this.selectValue = status;
    this.getList(this.current[0], this.selectValue);
  }
};
</script>
<style scoped>
.list-full-height {
  min-height: 100vh;
}
.status-select {
  width: 100px;
  /* float: right; */
}
</style>
